/*
*
* ARIANE JS
*
*/

$(document).ready(function(){

  var numberOfLi = $('.breadcrumb-ol-mobile li').length;

  if (numberOfLi > 3) {
    $('.breadcrumb-ol-mobile').addClass('breadcrumb-collapsed');
  }

  var breadcrumbItem = $('.breadcrumb-ol-mobile li').not('.active');
  var breadcrumbItemActive = $('.breadcrumb-ol-mobile .active');


  breadcrumbItemActive.on('click', function(){
    breadcrumbItem.slideToggle();
    $(this).toggleClass('active-collapse');
  })

});
